import homePage from './homePage';

export default homePage;
